import { Grid, styled, TextField, Typography } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { formatPrice } from '@retail/products/utils';
import { useTranslation } from 'react-i18next';
import { EditFieldButton } from '../EditFieldButton';

interface Props {
  description: string;
  price?: number;
  condition?: React.ReactNode;
  approximatelyEqual?: boolean;
  isActivePrice?: boolean;
  onEditCondition?: {
    onEdit: () => void;
    disabled?: boolean;
    disabledExplanation?: string;
  };
}

export function CalculusInfoRow({
  description,
  price,
  condition,
  isActivePrice = true,
  onEditCondition,
}: Props) {
  const t = useMyAssortmentTFunction();
  const { i18n } = useTranslation();

  return (
    <Grid container alignItems="center" width="100%">
      <Grid display="flex" size={3.5} alignSelf="center">
        <Typography variant="body2" color={isActivePrice ? 'text.primary' : 'text.disabled'}>
          {description}
        </Typography>
      </Grid>
      <Grid display="flex" pr={1} size={4.9}>
        <Typography component="div">{condition}</Typography>
        {onEditCondition && (
          <EditFieldButton
            onEdit={onEditCondition.onEdit}
            disabled={onEditCondition.disabled}
            title={onEditCondition.disabledExplanation}
          />
        )}
      </Grid>
      <Grid pr={1} display="flex">
        <Typography
          pl={1}
          variant="body2"
          sx={{
            textDecoration: isActivePrice ? 'none' : 'line-through',
            color: isActivePrice ? 'text.primary' : 'text.disabled',
          }}
        >
          {t('myAssortment.productCard.price', {
            price: price ? formatPrice(price, i18n.language) : '-',
          })}
        </Typography>
      </Grid>
    </Grid>
  );
}

export const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'maxWidth',
})<{ width?: number | string; }>(({ theme, width = 82 }) => ({
  minWidth: 68,

  '& .MuiOutlinedInput-root': {
    height: 32,
    width,
    maxWidth: 125,
    border: `1 px solid ${theme.vars.palette.divider}`,
    '>input': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
}));
